/** Тохируулсан алсын хостууд — next.config.ts-ийн remotePatterns-тэй тааруулна. */
/*
 * ! `next.config.ts`-ИЙН `remotePatterns`-ТОЙ ХАМТ ЗАСНА — хоёр газарт
 * ! тус тусад нь бичигдсэн тул нэгийг нь мартвал зураг чимээгүй алга болно.
 *
 * ! `cloud2.maximus.mn` нь ШИЛЖИЛТИЙН үеийнх (хуучин Laravel). `/api/website/`
 * ! шинэ API руу бүрэн шилжмэгц ХАСНА.
 */
const ALLOWED_HOSTS = new Set([
  'cloud.maximus.mn',
  'cloud2.maximus.mn',
  'devcloud.maximus.mn',
  'www.maximus.mn',
  'images.unsplash.com'
])

/**
 * next/image-д өгөх боломжтой эсэхийг шалгаж, боломжгүй бол null буцаана.
 *
 * Админаас алдаатай URL орж ирвэл (жишээ нь өөр орчны `http://localhost:3000/...`)
 * next/image алдаа шидэж БҮХ хуудсыг унагадаг. Тиймээс:
 *  - өөрийн сайт руу заасан үнэмлэхүй URL-ыг зам болгож хувиргана,
 *  - тохируулаагүй хостыг null болгож, дуудсан тал нь fallback үзүүлнэ.
 */
export const resolveImageSrc = (src?: string | null): string | null => {
  if (!src) {
    return null
  }

  const value = src.trim()

  if (!value) {
    return null
  }

  // Зам эсвэл data URI — шууд болно
  if (!/^https?:\/\//i.test(value)) {
    return value
  }

  let url: URL

  try {
    url = new URL(value)
  } catch {
    return null
  }

  if (ALLOWED_HOSTS.has(url.hostname)) {
    return value
  }

  // localhost / 127.0.0.1 гэх мэт өөр орчны хаяг — зөвхөн замыг нь авна
  if (['localhost', '127.0.0.1'].includes(url.hostname)) {
    return url.pathname + url.search
  }

  return null
}

/**
 * Видео (mp4, HLS m3u8)-ны хаягийг шалгана.
 *
 * ! Зурагнаас ЯЛГААТАЙ нь: `website/sections/x.mp4` мэт харьцангуй замыг
 * ! ЗӨВШӨӨРӨХГҮЙ. Хөтөч түүнийг web.maximus.mn-ээс хайж 404 авна — CMS
 * ! үнэмлэхүй URL өгөх ёстой. Зөвхөн `/videos/...` мэт үндсэн зам болно.
 *
 * ! `https://` нь ДУРЫН хост — `<video>` нь next/image-ийн `remotePatterns`-д
 * ! баригдахгүй, CMS ч админд наасан дурын https хаягийг зөвшөөрдөг. Жагсаалтаар
 * ! шүүвэл хадгалагдсан слайд сайт дээр чимээгүй постер болж хувирна. (hls.js-д
 * ! тэр хост CORS өгөх ёстой — үгүй бол mp4 руу шилжинэ.)
 */
export const resolveVideoSrc = (src?: string | null): string | null => {
  const value = src?.trim()

  if (!value) {
    return null
  }

  if (value.startsWith('/')) {
    return value.startsWith('//') ? null : value
  }

  if (/^https:\/\//i.test(value)) {
    try {
      return new URL(value).hostname ? value : null
    } catch {
      return null
    }
  }

  // http:// — өөр орчны localhost-ыг зам болгоно, бусдыг зурагтай ижил хостоор
  if (/^http:\/\//i.test(value)) {
    return resolveImageSrc(value)
  }

  return null
}
